import { render, staticRenderFns } from "./ImportLogs.vue?vue&type=template&id=4c23bd60&scoped=true"
import script from "./ImportLogs.vue?vue&type=script&lang=js"
export * from "./ImportLogs.vue?vue&type=script&lang=js"
import style0 from "./ImportLogs.vue?vue&type=style&index=0&id=4c23bd60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c23bd60",
  null
  
)

export default component.exports